import React, { useEffect, useState } from "react";

import SingleBook from "../../components/Book/SingleBook";
import axios from "axios";
import { SERVER_URL } from "../../api/url";

const BookGridMain = () => {
  const [data,setData]=useState([]);
  const [loading,setLoading]=useState(false)
  useEffect(()=>{
    fetchBooks()
  },[])
  const fetchBooks = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${SERVER_URL}/book`, {
        params: {
         
          page: 1,
          limit: 100,
        },
      });

      const fetchedBooks = response.data?.data?.currentDatas || [];
      setData(fetchedBooks)
     
    } catch (err) {
      console.error(err);
      // Handle errors (could show a toast or error message)
    } finally {
      setLoading(false);
    }
  };
 
  return (
    <div className="react-course-filter back__course__page_grid pb---40 pt---110">
      <div className="container pb---70">
       {
        !loading && (
          <div className="book-card-container row gy-5">
          {data.length===0 ?(
            <div className="course-message">
          <p className="no-courses">There are no avaliable book.</p>
        </div>
          ) :(
            
            data.map((book, index) => {
              return (
                <div className="col-lg-3 col-md-6 col-sm-6" key={index}>
                  {<SingleBook book={book}  />}
                </div>
              );
            })
          )}
           
          </div>
        )
       }
      </div>
    </div>
  );
};

export default BookGridMain;
